import { render, staticRenderFns } from "./NewsPost0.vue?vue&type=template&id=c0f8e17a&"
import script from "./NewsPost0.vue?vue&type=script&lang=ts&"
export * from "./NewsPost0.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports